/* Local Unit Agreements */

export enum LocalUnitAgreementPermissions {
  updateStatusPrimaryCostAgreement = 'UpdateStatusPrimaryCostAgreement',
  managePrimaryCostAgreement = 'ManagePrimaryCostAgreement',
  managePrimaryCostAnnualPlan = 'ManagePrimaryCostAnnualPlan',
  managePrimaryCostAnnualPlanItem = 'ManagePrimaryCostAnnualPlanItem',
  manageAgreementChapter = 'ManageAgreementChapter',
  manageAgreementChapterItem = 'ManageAgreementChapterItem',
  approvePrimaryCostAnnualPlanItem = 'ApprovePrimaryCostAnnualPlanItem',
  readPrimaryCostAnnualPlan = 'ReadPrimaryCostAnnualPlan',
  readPrimaryCostAccrualItem = 'ReadPrimaryCostAccrualItem',
  readAgreementChapter = 'ReadAgreementChapter',
  managePrimaryCostReportItem = 'ManagePrimaryCostReportItem',
  readPrimaryCostReport = 'ReadPrimaryCostReport',
  managePrimaryCostReport = 'ManagePrimaryCostReport',
  managePrimaryCostInvoiceItem = 'ManagePrimaryCostInvoiceItem',
  managePrimaryCostInvoice = 'ManagePrimaryCostInvoice',
  readPrimaryCostInvoice = 'ReadPrimaryCostInvoice',
  approveDenyPrimaryCostReport = 'ApproveDenyPrimaryCostReport',
  sendPrimaryCostReportForApproval = 'SendPrimaryCostReportForApproval',
  approveDenyPrimaryCostInvoice = 'ApproveDenyPrimaryCostInvoice',
  uploadPrimaryCostInvoiceAttachment = 'UploadPrimaryCostInvoiceAttachment',
  readPrimaryCostInvoicePDF = 'ReadPrimaryCostInvoicePDF'
}
export enum LocalUnitAgreementAccrualPermissions {
  sendPrimaryCostAccrualForApproval = 'SendPrimaryCostAccrualForApproval',
  approveDenyPrimaryCostAccrual = 'ApproveDenyPrimaryCostAccrual',
  readPrimaryCostAccrualPDF = 'ReadPrimaryCostAccrualPDF',
  managePrimaryCostAccrualItem = 'ManagePrimaryCostAccrualItem',
  readPrimaryCostAccrual = 'ReadPrimaryCostAccrual',
  managePrimaryCostAccrual = 'ManagePrimaryCostAccrual',
}

/* Service Beneficiary Agreements */
export enum ServiceAgreementPermissions {
  updateStatusServiceAgreement= 'UpdateStatusServiceAgreement',
  manageServiceAgreement = 'ManageServiceAgreement',
  manageAgreementPG = 'ManageAgreementPG',
  manageAgreementPGItem = 'ManageAgreementPGItem',
  manageServiceAnnualPlan = 'ManageServiceAnnualPlan',
  manageServiceAnnualPlanItem = 'ManageServiceAnnualPlanItem',
  approveServiceAnnualPlanItem = 'ApproveServiceAnnualPlanItem',
  readServiceInvoice = 'ReadServiceInvoice',
  readServiceInvoiceItem = 'ReadServiceInvoiceItem',
  approveDenyServiceInvoice = 'ApproveDenyServiceInvoice'
}
export enum ServiceAgreementAccrualPermissions {
  approveDenyServiceAccrual = 'ApproveDenyServiceAccrual',
  readServiceAccrualPDF = 'ReadServiceAccrualPDF',
  readServiceAccrual = 'ReadServiceAccrual',
  manageServiceAccrual = 'ManageServiceAccrual',
  manageServiceAccrualItem = 'ManageServiceAccrualItem'
}

/* Markup */
export enum MarkupPermissions {
  manageMarkup= 'ManageMarkup'
}

/* OrgUnit */
export enum OrgUnitPermissions {
  manageOrgUnit= 'ManageOrgUnit'
}

/* Local Unit */
export enum LocalUnitPermissions {
  manageLocalUnit = 'ManageLocalUnit',
  manageLocalUnitLocation = 'ManageLocalUnitLocation',
  manageLocalUnitLocationPG = 'ManageLocalUnitLocationPG'
}

/* Service Beneficiary Unit */
export enum ServiceBeneficiaryUnitPermissions {
  manageServiceBeneficiaryUnit = 'ManageServiceBeneficiaryUnit',
  manageServiceBeneficiaryUnitLocation = 'ManageServiceBeneficiaryUnitLocation',
  manageServiceBeneficiaryUnitLocationPG = 'ManageServiceBeneficiaryUnitLocationPG'
}
/* Pooling Entity */
export enum PoolingEntityPermissions {
  managePoolingEntity = 'ManagePoolingEntity'
}

/* Function */
export enum FunctionPermissions {
  manageAgileUnit = 'ManageAgileUnit',
  manageChapterSplit = 'ManageChapterSplit',
  manageChapter = 'ManageChapter'
}

/* People verification */
export enum PeopleVerificationPermissions {
  manageEmployeeGapReport = 'ManageEmployeeGapReport',
  updateStatusEmployeeGapReport = 'UpdateStatusEmployeeGapReport',
  updateStatusEmployeeGapReportItem = 'UpdateStatusEmployeeGapReportItem',
  readEmployeeGapReport = 'ReadEmployeeGapReport'
}

/* APPs Cost Import */
export enum AppsCostImportPermissions {
  readAppCostImport = 'ReadAppCostImport',
  createAppCostImport = 'CreateAppCostImport'
}

/* APPs Input */
export enum AppsInputPermissions {
  readAppInput = "ReadAppInput",
  manageAppInput = "ManageAppInput",
  sendAppInputForApprovalPhase1 = "SendAppInputForApprovalPhase1",
  approveAppInputPhase1 = "ApproveAppInputPhase1",
  sendAppInputForApprovalPhase2 = "SendAppInputForApprovalPhase2",
  approveAppInputPhase2 = "ApproveAppInputPhase2",
  sendAppInputForApprovalPhase3 = "SendAppInputForApprovalPhase3",
  approveAppInputPhase3 = "ApproveAppInputPhase3",
}

/* APPs Outflow */
export enum AppsOutflowPermissions {
  readAppOutflow = "ReadAppOutflow",
  approveAppOutflow = "ApproveAppOutflow"
}